import {call, put, takeLatest,} from "@redux-saga/core/effects";
import * as Services from "../../Services/";
import {CityActions} from './Slice';
import {DELETE_CITY, GET_CITIES, SAVE_CITY, SearchCityParams} from "./Types"
import {PayloadAction} from "@reduxjs/toolkit";
import {LOADING_CITIES, LOADING_SAVE_CITY} from "../Loading/Types";
import {
  comparator,
  setLoadingIdle,
  setLoadingPending,
  setLoadingRejected,
  setLoadingResolve,
  toast
} from "../../Utils/Utils";

function* getCities(action ?: PayloadAction<SearchCityParams>) {
  try {
    yield put (setLoadingPending(LOADING_CITIES));
    const res = yield call(Services.getCities,action?.payload);
    if (!res?.results) {
      throw Error('There was an error.');
    } else {
      const cities: any = res.results;
      cities.sort(comparator());
      yield put(CityActions.setCities(cities));
      yield put (setLoadingResolve(LOADING_CITIES));
      yield put (setLoadingIdle(LOADING_CITIES));
    }
  } catch (e) {
    toast("There was an error, please try again.", "error");
    console.error(e);
    yield put(setLoadingRejected(LOADING_CITIES, e.message));
  }
}

function* deleteCity({payload} : any) {
  try {
    const cityKey = payload._KEY;
    const res = yield call (Services.deleteCity, cityKey);
    if(res?.success){
      yield call (Services.deleteZones, cityKey);
      yield call (Services.deleteRegionCities, cityKey);
      yield call(getCities);
      toast('Ciudad eliminada');
    }else{
      throw Error('There was an error.');
    }
  } catch (e) {
    toast("There was an error, please try again.", "error");
    console.error(e);
  }
}

function* saveCity({payload} : any) {
  try {
    yield put (setLoadingPending(LOADING_SAVE_CITY));
    delete payload.cityInfo;
    delete payload.zonesInfo;
    delete payload.state;

   const res = yield call (Services.saveCity, payload);

   if(res.success){
     yield call (getCities);
     toast(`${payload._KEY ? 'Ciudad editada': 'Ciudad agregada'}`);
     yield put (setLoadingResolve(LOADING_SAVE_CITY));
     yield put (setLoadingIdle(LOADING_SAVE_CITY));
    }else{
      throw Error('There was an error.');
    }
  } catch (e) {
    toast("There was an error, please try again.", "error");
    console.error(e);
  }
}

export function* citySaga() {
  yield takeLatest(GET_CITIES, getCities);
  yield takeLatest(DELETE_CITY, deleteCity);
  yield takeLatest(SAVE_CITY,saveCity);
}
